import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { KirtalLyricsPadListData, KirtanLyricsdata, selectedFilterDataType } from "~/interface/kirtan-lyrics/kirtan-lyrics";
import { MstPersonType } from "~/type";
import { SELECTED_KIRTAN_ID } from "~/utils/constant";

interface KirtanLyricsInitialdata {
  kirtanLyricsData: KirtanLyricsdata[];
  bhav: MstPersonType[];
  rachayta: MstPersonType[];
  raagDhaal: MstPersonType[];
  k_book: MstPersonType[];
  k_prasang: MstPersonType[];
  k_place: MstPersonType[];
  selectedKirtanId: number | null;
  kirtanPadList: KirtalLyricsPadListData[] | [];
  kirtanCharacters: string[];
  selectedPadList: KirtalLyricsPadListData | null;
  padArray: string[];
  selectedBhav: selectedFilterDataType[];
  selectedRaagDhal: selectedFilterDataType[];
  selectedRachayta: selectedFilterDataType[];
  selectedKBook: selectedFilterDataType[];
  selectedKPrasang: selectedFilterDataType[];
  selectedKPlace: selectedFilterDataType[];
  hoveredChar?: string | null;
  isTouchBar?: boolean;
}

const initialState: KirtanLyricsInitialdata = {
  kirtanLyricsData: [],
  bhav: [],
  rachayta: [],
  raagDhaal: [],
  k_book: [],
  k_prasang: [],
  k_place: [],
  selectedKirtanId: null,
  kirtanPadList: [],
  kirtanCharacters: [],
  selectedPadList: null,
  padArray: [],
  selectedBhav: [],
  selectedRaagDhal: [],
  selectedRachayta: [],
  selectedKBook: [],
  selectedKPrasang: [],
  selectedKPlace: [],
  hoveredChar: null,
  isTouchBar: false,
};

export const kirtanLyricsSlice = createSlice({
  name: "kirtanLyrics",
  initialState,
  reducers: {
    setKirtanLyricsData: (state, action: PayloadAction<KirtanLyricsdata[]>) => {
      state.kirtanLyricsData = action.payload;
    },
    setBhavData: (state, action: PayloadAction<MstPersonType[]>) => {
      state.bhav = action.payload;
    },
    setRachayataData: (state, action: PayloadAction<MstPersonType[]>) => {
      state.rachayta = action.payload;
    },
    setRaagDhaalData: (state, action: PayloadAction<MstPersonType[]>) => {
      state.raagDhaal = action.payload;
    },
    setSelectedKirtanId: (state, action: PayloadAction<number | null>) => {
      state.selectedKirtanId = action.payload;
      if (typeof window !== "undefined") {
        sessionStorage.setItem(SELECTED_KIRTAN_ID, JSON.stringify(action.payload));
      }
    },
    setKirtanLyricsPadList: (state, action: PayloadAction<KirtalLyricsPadListData[]>) => {
      state.kirtanPadList = action.payload;
    },
    setSelectedPadList: (state, action: PayloadAction<KirtalLyricsPadListData>) => {
      state.selectedPadList = action.payload;
    },
    setPadArray: (state, action: PayloadAction<string[]>) => {
      state.padArray = action.payload;
    },
    setKirtanCharacters: (state, action: PayloadAction<string[]>) => {
      state.kirtanCharacters = action.payload || [];
    },
    setSelectedBhav: (state, action: PayloadAction<selectedFilterDataType[]>) => {
      state.selectedBhav = action.payload;
    },
    setSelectedRaagDhal: (state, action: PayloadAction<selectedFilterDataType[]>) => {
      state.selectedRaagDhal = action.payload;
    },
    setSelectedRachayta: (state, action: PayloadAction<selectedFilterDataType[]>) => {
      state.selectedRachayta = action.payload;
    },
    addSelectedBhav: (state, action: PayloadAction<selectedFilterDataType>) => {
      state.selectedBhav.push(action.payload);
    },
    addSelectedRaagDhal: (state, action: PayloadAction<selectedFilterDataType>) => {
      state.selectedRaagDhal.push(action.payload);
    },
    addSelectedRachayta: (state, action: PayloadAction<selectedFilterDataType>) => {
      state.selectedRachayta.push(action.payload);
    },
    removeSelectedBhav: (state, action: PayloadAction<selectedFilterDataType>) => {
      state.selectedBhav = state.selectedBhav.filter((bhav) => bhav.id !== action.payload.id);
    },
    removeSelectedRaagDhal: (state, action: PayloadAction<selectedFilterDataType>) => {
      state.selectedRaagDhal = state.selectedRaagDhal.filter((raagDhal) => raagDhal.id !== action.payload.id);
    },
    removeSelectedRachayta: (state, action: PayloadAction<selectedFilterDataType>) => {
      state.selectedRachayta = state.selectedRachayta.filter((rachayta) => rachayta.id !== action.payload.id);
    },
    setSelectedKBook: (state, action: PayloadAction<selectedFilterDataType[]>) => {
      state.selectedKBook = action.payload;
    },
    setSelectedKPrasang: (state, action: PayloadAction<selectedFilterDataType[]>) => {
      state.selectedKPrasang = action.payload;
    },
    setSelectedKPlace: (state, action: PayloadAction<selectedFilterDataType[]>) => {
      state.selectedKPlace = action.payload;
    },
    addSelectedKBook: (state, action: PayloadAction<selectedFilterDataType>) => {
      state.selectedKBook.push(action.payload);
    },
    addSelectedKPrasang: (state, action: PayloadAction<selectedFilterDataType>) => {
      state.selectedKPrasang.push(action.payload);
    },
    addSelectedKPlace: (state, action: PayloadAction<selectedFilterDataType>) => {
      state.selectedKPlace.push(action.payload);
    },
    removeSelectedKBook: (state, action: PayloadAction<selectedFilterDataType>) => {
      state.selectedKBook = state.selectedKBook.filter((item) => item.id !== action.payload.id);
    },
    removeSelectedKPrasang: (state, action: PayloadAction<selectedFilterDataType>) => {
      state.selectedKPrasang = state.selectedKPrasang.filter((item) => item.id !== action.payload.id);
    },
    removeSelectedKPlace: (state, action: PayloadAction<selectedFilterDataType>) => {
      state.selectedKPlace = state.selectedKPlace.filter((item) => item.id !== action.payload.id);
    },
    setHoveredChar: (state, action: PayloadAction<string | null>) => {
      state.hoveredChar = action.payload;
    },
    setIsTouchBar: (state, action: PayloadAction<boolean>) => {
      state.isTouchBar = action.payload;
    },
    setKirtanBookData: (state, action: PayloadAction<MstPersonType[]>) => {
      state.k_book = action.payload;
    },
    setKirtanPrasangData: (state, action: PayloadAction<MstPersonType[]>) => {
      state.k_prasang = action.payload;
    },
    setKirtanPlaceData: (state, action: PayloadAction<MstPersonType[]>) => {
      state.k_place = action.payload;
    },
  },
});

export const {
  setKirtanLyricsData,
  setBhavData,
  setRachayataData,
  setRaagDhaalData,
  setSelectedKirtanId,
  setKirtanLyricsPadList,
  setSelectedPadList,
  setPadArray,
  setKirtanCharacters,
  setSelectedBhav,
  setSelectedRaagDhal,
  setSelectedRachayta,
  setSelectedKBook,
  setSelectedKPrasang,
  setSelectedKPlace,
  addSelectedBhav,
  addSelectedRaagDhal,
  addSelectedRachayta,
  addSelectedKBook,
  addSelectedKPrasang,
  addSelectedKPlace,
  removeSelectedBhav,
  removeSelectedRaagDhal,
  removeSelectedRachayta,
  removeSelectedKBook,
  removeSelectedKPrasang,
  removeSelectedKPlace,
  setHoveredChar,
  setIsTouchBar,
  setKirtanBookData,
  setKirtanPrasangData,
  setKirtanPlaceData,
} = kirtanLyricsSlice.actions;

export default kirtanLyricsSlice.reducer;
